module.exports = __webpack_public_path__ + "static/media/22-4.05ece463.mp3";